<script>
	import { navigate } from "svelte-navigator";
	import { login_kroger } from "../tastummy.ts";

	// get code from url query parameter
	const params = new URLSearchParams(window.location.search);
	const code = params.get("code");
	let error;
	login_kroger(code)
		.then((res) => {
			navigate("/settings");
		})
		.catch((e) => {
			console.log(e);
			error = "Error logging in";
		});
</script>

<div>processing auth token</div>
{#if error}
	<p class="error">{error}</p>
{/if}
